import React, { useRef, useState } from 'react';
import Modal from 'react-modal';
import 'video.js/dist/video-js.css';
import VideoJS from './VideoJS';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { useVideoModal, useVideoModalUpdate }  from "../context/ModalContext";
import { gaVideoButton, gaVideoProgress } from '../../utils/gatags';

import './VideoPopupModal.css'
// import videojs from 'video.js';
import 'video.js/dist/video-js.css';

const VideoPopupModal = () => {

  const videoJsOptions = {
    poster: require('../../assets/video/Biosimilar-future-lessons-from-other-therapy-areas-poster.jpg'),
    class: "video-js vjs-default-skin vjs-big-play-centered vjs-show-big-play-button-on-pause",
    autoplay: false,
    controls: true,
    responsive: true,
    fluid: true,
  //   datasetup: { "poster": require('../../assets/video/MOA_Elucirem_US_8feb-poster.jpg') },
    sources: [{
    src: require('../../assets/video/Biosimilar-future-lessons-from-other-therapy-areas.mp4'),
    type: 'video/mp4'
    }]
  };

  const handlePlayerReady = (player) => {

    player.on("timeupdate", function () {
      videoProgress(player);
    });

    player.on("pause", function (e) {
      gaVideoButton( player.lastSource_.player, "pause")
    });

    player.on("play", function (e) {
      gaVideoButton( player.lastSource_.player, "play")
    });
     
    player.on("ended", function(){
        player.bigPlayButton.show();
        player.currentTime(0);
        player.hasStarted(false);
        player.trigger("ready");
        fireArrayReset();
    })
  };

    const videoModalState = useVideoModal(true);
    const setVideoModalState = useVideoModalUpdate();
    const [isVisible, setIsVisible] = useState(false);

    Modal.setAppElement('#root')

    const customStyles = {
        overlay: {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          padding: 40,
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          zIndex: 1000
        },
        content : {
          position: 'relative',
          background: '#FFFFFF',
          inset: 0,
          margin: 20,
          overflow: 'unset',
          border: "none",
          borderTopRightRadius: 4,
          maxwidth: "800px"
        }
      };

      let fireArray = [false, false, false, false, false, false, false, false, false, false ]

      const fireArrayReset = () => {
        fireArray.map((num, index) => {
          fireArray[index] = false;
        })
      }

      const videoProgress = (e) => {

        let duration = e.duration();
        let currenttime = e.currentTime();
        let currentVideo = e.lastSource_.player;

        if ( !fireArray[0] ) {
            if ( Math.round((currenttime / duration) * 100) >= 10 && Math.round((currenttime / duration) * 100) < 20 ) {
                console.log("------------ 10%");
                fireArray[0] = true
                gaVideoProgress(10, currentVideo);
            }
        }
        if ( !fireArray[1] ) {
          if ( Math.round((currenttime / duration) * 100) >= 20 && Math.round((currenttime / duration) * 100) < 30 ) {
                console.log("------------ 20%");
                fireArray[1] = true
                gaVideoProgress(20, currentVideo);
            }
        }
        if ( !fireArray[2] ) {
          if ( Math.round((currenttime / duration) * 100) >= 30 && Math.round((currenttime / duration) * 100) < 40 ) {
                console.log("------------ 30%");
                fireArray[2] = true
                gaVideoProgress(30, currentVideo);
            }
        }
        if ( !fireArray[3] ) {
          if ( Math.round((currenttime / duration) * 100) >= 40 && Math.round((currenttime / duration) * 100) < 50 ) {
                console.log("------------ 40%");
                fireArray[3] = true
                gaVideoProgress(40, currentVideo);
            }
        }
        if ( !fireArray[4] ) {
          if ( Math.round((currenttime / duration) * 100) >= 50 && Math.round((currenttime / duration) * 100) < 60 ) {
                console.log("------------ 50%");
                fireArray[4] = true
                gaVideoProgress(50, currentVideo);
            }
        }
        if ( !fireArray[5] ) {
          if ( Math.round((currenttime / duration) * 100) >= 60 && Math.round((currenttime / duration) * 100) < 70 ) {
                console.log("------------ 60%");
                fireArray[5] = true
                gaVideoProgress(60, currentVideo);
            }
        }
        if ( !fireArray[6] ) {
          if ( Math.round((currenttime / duration) * 100) >= 70 && Math.round((currenttime / duration) * 100) < 80 ) {
                console.log("------------ 70%");
                fireArray[6] = true
                gaVideoProgress(70, currentVideo);
            }
        }
        if ( !fireArray[7] ) {
          if ( Math.round((currenttime / duration) * 100) >= 80 && Math.round((currenttime / duration) * 100) < 90 ) {
                console.log("------------ 80%");
                fireArray[7] = true
                gaVideoProgress(80, currentVideo);
            }
        }
        if ( !fireArray[8] ) {
          if ( Math.round((currenttime / duration) * 100) >= 90 && Math.round((currenttime / duration) * 100) < 1000 ) {
                console.log("------------ 90%");
                fireArray[8] = true
                gaVideoProgress(90, currentVideo);
            }
        }
        if ( !fireArray[9] ) {
            if ( Math.round((currenttime / duration) * 100) === 100 ) {
                console.log("------------ 100%");
                fireArray[9] = true
                gaVideoProgress(100, currentVideo);
            }
        }
      }


      function closeModal(){
        setVideoModalState(false);
        setIsVisible(false);
      }

      function afterOpenModal(){
        fireArrayReset();
      }

      function afterClose(){
        fireArrayReset();
      }

    return (
      <Modal
            closeTimeoutMS={0}
            isOpen={ videoModalState }
            onAfterOpen={afterOpenModal}
            onAfterClose={afterClose}
            onRequestClose={closeModal}
            style={customStyles}
            contentLabel="Example Modal"
            id="react-modal-video"
            >
              <div className="modal-header-transparent video-head">
                <div className="close-btn-transparent" onClick={closeModal}><FontAwesomeIcon icon={faTimes} /></div>
              </div>
              <VideoJS options={videoJsOptions} onReady={handlePlayerReady} />

        </Modal>
    );
};


export default VideoPopupModal;